import styled from 'styled-components';

export const ContentWrapper = styled.div(({ theme }) =>
  theme.withMedia({
    color: theme.colors.lightGray,
    fontSize: '16px',
    fontWeight: 300,
    lineHeight: '140%',
    ul: {
      li: {
        marginBottom: '16px'
      }
    }
  })
);
